import { createCommand } from 'lexical'

export const FONT_SIZES = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '30px',
] as const
export type FontSize = (typeof FONT_SIZES)[number]
export const FORMAT_FONT_SIZE_COMMAND = createCommand<FontSize>()

export const FORMAT_COLOR_COMMAND = createCommand<string>()

export const FORMAT_BLOCK_PARAGRAPH_COMMAND = createCommand()
export const FORMAT_BLOCK_QUOTE_COMMAND = createCommand()

export const BLOCK_HEADING_LEVELS = ['h1', 'h2', 'h3'] as const
export type BlockHeadingLevel = (typeof BLOCK_HEADING_LEVELS)[number]
export const FORMAT_BLOCK_HEADING_COMMAND = createCommand<BlockHeadingLevel>()

export const BLOCK_LIST_VARIANTS = ['number', 'bullet'] as const
export type BlockListVariant = (typeof BLOCK_LIST_VARIANTS)[number]
export const FORMAT_BLOCK_LIST_COMMAND = createCommand<BlockListVariant>()

export type BlockType = 'paragraph' | 'quote' | BlockHeadingLevel | BlockListVariant

export function isBlockHeadingLevel(blockType: BlockType): blockType is BlockHeadingLevel {
  return (BLOCK_HEADING_LEVELS as readonly string[]).includes(blockType)
}
